import { render, staticRenderFns } from "./TypSelect.vue?vue&type=template&id=599e2e22&"
import script from "./TypSelect.vue?vue&type=script&lang=ts&"
export * from "./TypSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports